import { render, staticRenderFns } from "./AnchorImageSlider.vue?vue&type=template&id=19de5e22&scoped=true"
import script from "./AnchorImageSlider.vue?vue&type=script&lang=js"
export * from "./AnchorImageSlider.vue?vue&type=script&lang=js"
import style0 from "./AnchorImageSlider.vue?vue&type=style&index=0&id=19de5e22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de5e22",
  null
  
)

export default component.exports